<template>
  <div class="total-votes">
    <strong>{{ component.props?.label || 'TOTAL VOTES' }}:</strong>
    <span :class="{ 'has-text-danger': overUnder !== 0 }">
      {{ sum }}
    </span>
    <span class="available">(of {{ totalVotesAvailable }} available)</span>
    <p v-if="form?.answers?.[questionId]?.choice === 'b' && overUnder !== 0" class="warn">
      Total directed votes must equal the votes available.
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  component: { type: Object, required: true },
  shareholder: { type: Object, default: () => ({}) },
  mode: { type: String, default: 'vote' },
  form: { type: Object, default: null },
  shareValue: { type: Number, default: 2 },
  ballotComponents: { type: Array, default: () => [] },
})

const questionId = computed(() => props.component.props?.questionId)

const directed = computed(() => {
  if (!props.form || !questionId.value) return {}
  return props.form.answers?.[questionId.value]?.directed || {}
})

const sum = computed(() =>
  Object.values(directed.value).reduce((acc, v) => acc + (parseFloat(v) || 0), 0),
)

const totalVotesAvailable = computed(() => {
  const shares = props.form?.signcustodian
    ? Number(props.form.custodianShares || 0)
    : Number(props.shareholder.shares || 0)
  return shares * props.shareValue
})

const overUnder = computed(() => sum.value - totalVotesAvailable.value)
</script>

<style scoped>
.total-votes {
  padding: 10px 0;
  font-size: 18px;

  .available {
    margin-left: 6px;
    color: #888;
    font-size: 0.9rem;
  }

  .warn {
    color: #c33;
    font-size: 0.9rem;
    margin-top: 4px;
  }
}
</style>
